import { createFromIconfontCN } from "@ant-design/icons-vue"

export default createFromIconfontCN({
  scriptUrl: "//at.alicdn.com/t/c/font_4381423_3ekla0b3w6i.js"
})
